import * as cookieStorage from './../../actions/common/cookieStorage';

const cStorage = cookieStorage.getCookieStorage();

const STORAGE_KEY = 'depositCart';

export function addToDepositCart(ean, isSet = false, isAtvSet = false) {
    let cart = restoreDepositCartFromStorage();

    const eanIndex = cart.items.findIndex((item) => item.ean === ean);

    if (eanIndex >= 0) {
        cart.items[eanIndex].quantity++;
    } else {
        cart.items.push({
            ean,
            quantity: 1,
            isSet,
            isAtvSet,
        });
    }

    cStorage.setObject(STORAGE_KEY, cart);
    return cart;
}

export function restoreDepositCartFromStorage() {
    const cartFromStorage = cStorage.getObject(STORAGE_KEY);

    if (cartFromStorage === null) {
        return { items: [] };
    }

    return cartFromStorage;
}

export function removeFromDepositCart(ean) {
    const cart = restoreDepositCartFromStorage();
    const eanIndex = cart.items.findIndex((item) => item.ean === ean);

    if (eanIndex >= 0) {
        cart.items.splice(eanIndex, 1);
    }

    cStorage.setObject(STORAGE_KEY, cart);
    return cart;
}

export function updateDepositQuantity(ean, newQuantity) {
    const cart = restoreDepositCartFromStorage();
    const eanIndex = cart.items.findIndex((item) => item.ean === ean);

    if (eanIndex >= 0) {
        cart.items[eanIndex].quantity = Math.max(1, newQuantity);
    }

    cStorage.setObject(STORAGE_KEY, cart);
    return cart;
}

export function clearDepositCart() {
    cStorage.setObject(STORAGE_KEY, { items: [] });
    return { items: [] };
}

export function getDepositCartItemsCount() {
    const cart = restoreDepositCartFromStorage();
    return cart.items.reduce((total, item) => {
        return total + item.quantity;
    }, 0);
}
